'use strict';

import angular from 'angular';
import routes from './admin.routes';
import AdminController from './admin.controller';
import UsersController from './users.controller';
import UserModalController from './user.modal.controller';
import UserPasswordModalController from './userPassword.modal.controller';

import CompanyGLsController from './companyGLs.controller';
import CompanyGLsUploadController from './companyGLs.upload.controller';
import CompanyGLFormController from './companyGL.form.controller';
import AccountingUnitsController from './accountingUnits.controller';
import AccountingUnitsUploadController from './accountingUnits.upload.controller';
import AccountingUnitFormController from './accountingUnit.form.controller';
import LocationCodesController from './locationCodes.controller';
import LocationCodesUploadController from './locationCodes.upload.controller';
import LocationCodeFormController from './locationCode.form.controller';
import CompanyAddressesController from './companyAddresses.controller';
import CompanyAddressesUploadController from './companyAddresses.upload.controller';
import CompanyAddressFormController from './companyAddress.form.controller';
import JobClassController from './jobClass.controller';
import JobClassUploadController from './jobClass.upload.controller';

export default angular.module('wftOrderFormApp.admin', ['wftOrderFormApp.auth', 'ui.router'])
  .config(routes)
  .controller('AdminController', AdminController)
  .controller('UsersController', UsersController)
  .controller('UserModalController', UserModalController)
  .controller('UserPasswordModalController', UserPasswordModalController)
  .controller('CompanyGLsController', CompanyGLsController)
  .controller('CompanyGLsUploadController', CompanyGLsUploadController)
  .controller('CompanyGLFormController', CompanyGLFormController)
  .controller('AccountingUnitsController', AccountingUnitsController)
  .controller('AccountingUnitsUploadController', AccountingUnitsUploadController)
  .controller('AccountingUnitFormController', AccountingUnitFormController)
  .controller('LocationCodesController', LocationCodesController)
  .controller('LocationCodesUploadController', LocationCodesUploadController)
  .controller('LocationCodeFormController', LocationCodeFormController)
  .controller('CompanyAddressesController', CompanyAddressesController)
  .controller('CompanyAddressesUploadController', CompanyAddressesUploadController)
  .controller('CompanyAddressFormController', CompanyAddressFormController)
  .controller('JobClassController', JobClassController)
  .controller('JobClassUploadController', JobClassUploadController)
  .name;



// WEBPACK FOOTER //
// ./client/app/admin/index.js